<template>
    <div>
        <!-- <div class="d-flex justify-end">
            <v-btn color="yellow darken-3" class="mr-2" :disabled="cartStore.isProcedureInCart" @click="addToCart">
                Agregar a Mis Pagos
                <v-icon right small>fas fa-briefcase</v-icon>
            </v-btn>
            <v-btn color="yellow darken-3" :disabled="cartStore.isProcedureInCart" @click="addAndGoToCart">
                Pagar ahora
                <v-icon right small>fas fa-credit-card</v-icon>
            </v-btn>
        </div> -->
        <div class="d-flex justify-end">
            <div  class="d-flex justify-end" >
                <v-btn :color="pantoneBlack" tile class="white--text" :disabled="cartStore.isProcedureInCart" @click="addToCart">
                    Agregar a Mis Pagos
                    <v-icon right small>fas fa-briefcase</v-icon>
                </v-btn>
            </div>
            <div   class="d-flex justify-end  ">
                <v-btn :color="civic" class="white--text  mx-2"  tile :disabled="cartStore.isProcedureInCart" @click="addAndGoToCart">
                    Pagar ahora
                    <v-icon right small>fas fa-credit-card</v-icon>
                </v-btn>
            </div>
        </div>
        <div class="d-flex justify-end pt-2" v-if="cartStore.isProcedureInCart">
            <label class="align-end">** El trámite ya fue agregado a Mis Pagos</label>
        </div>

    </div>


</template>

<script>
import {mapActions, mapState} from "vuex";
import {addToCartRequest, procedureInCartRequest} from "bestgob-core/api/models";

export default {
    name: "Cart",
    props: ['field', 'readonly', 'label', 'formValues', 'stageId', 'procedureId'],

    computed: {
        ...mapState({cartStore: state => state.cart})
    },

    data(){
        return {
            civic: '#97c93e',
            pantoneBlack: '#071b2c'
        }
    },

    mounted() {
        this.fetchIsProcedureInCart()
    },

    methods: {
        ...mapActions('cart', ['getIsProcedureInCart', 'addProcedureToCart']),

        fetchIsProcedureInCart(){
            let request = procedureInCartRequest();
            request.procedure_id = this.procedureId
            request.stage_id = this.stageId
            request.field_id = this.field.id

            //Call to VueX
            this.getIsProcedureInCart(request)
        },

        addToCart(){
            let request = addToCartRequest()
            request.field_id = this.field.id
            request.stage_id = this.stageId

            //Call to VueX
            this.addProcedureToCart(request)
        },

        addAndGoToCart(){
            this.addToCart()

            setTimeout(() => {
                this.$router.push({name: 'portfolio', params: {step: 1}})
            }, 1000 )

        }
    }
}
</script>